import { error, redirect } from '@sveltejs/kit';

import { seoConfig } from '@shared/config';
import type { Order } from '@shared/types';

import { artworksPageApi } from '@pages/artworks';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params, fetch, url, parent }) => {
  const { configurations } = await parent();

  const page = +(params?.page?.replace(/^page-/, '') ?? 1); // get only number from page param
  const loadMore = +(url.searchParams.get('loadMore') ?? 0);
  const category = params.classificationCategory;
  const classification = params.nameOfClassification;

  const { artworks, totalCount, maxPage } = await artworksPageApi.readData({
    fetch,
    url,
    page,
    loadMore,
    institutionId: configurations.id,
    sort: url.searchParams.get('column') ?? 'year',
    order: (url.searchParams.get('order') ?? 'desc') as Order,
    [category]: classification,
  });

  if (page > maxPage) {
    throw redirect(302, `/artworks/page-${maxPage}`);
  }

  if (artworks.length === 0) {
    throw error(404, 'Page not found');
  }

  const breadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'Artworks',
      slug: '/artworks',
      canonical: true,
    },
    {
      name: 'Classification',
      slug: `/artworks/classification-${category}-${classification}`,
      canonical: true,
    },
  ];

  const seo = seoConfig.artworks({ galleryName: configurations.name, breadcrumbs });

  return {
    artworks,
    totalCount,
    page,
    loadMore,
    seo,
    configurations,
  };
};
